<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont0">{{ $t("emailGroup.queryEmailGroup") }}</span>
    </p>
    <el-table
      :data="emailGroupList"
      tooltip-effect="dark"
      style="width:95%;margin:auto"
    >
      <!-- Email群名称-->
      <el-table-column
        prop="groupName"
        :label="$t('emailGroup.emailGroupName')"
        align="left"
        min-width="150"
      ></el-table-column>
      <!-- 群摘要/描述 -->
      <el-table-column
        prop="groupDescription"
        :label="$t('emailGroup.groupDescription')"
        align="left"
        min-width="150"
      ></el-table-column>
      <!-- 人数 -->
      <el-table-column
        prop="peopleCount"
        :label="$t('emailGroup.peopleCount')"
        align="right"
        min-width="30"
      ></el-table-column>
      <!-- 创建日期 -->
      <el-table-column
        :formatter="createTimeFormat"
        prop="createTime"
        :label="$t('emailGroup.createDate')"
        align="center"
        min-width="70"
      ></el-table-column>
      <!-- 上次公告 -->
      <el-table-column
        :formatter="createTimeFormat1"
        prop="lastAnnouncement"
        :label="$t('emailGroup.lastAnnouncement')"
        align="center"
        min-width="80"
      ></el-table-column>
      <!-- 状态 -->
      <el-table-column
        prop="state"
        :label="$t('emailGroup.state')"
        align="center"
        min-width="30"
      >
        <template slot-scope="scope">
          <!-- 有效 -->
          <span v-if="scope.row.state == 0">{{ $t("emailGroup.void") }}</span>
          <!-- 作废 -->
          <span v-if="scope.row.state == 1">{{
            $t("emailGroup.effective")
          }}</span>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column :label="$t('common.operation')" align="center">
        <template slot-scope="scope">
          <el-button size="text">{{ $t("emailGroup.historical") }}</el-button>
          <span style="color:#66b1ff;">|</span>
          <el-button size="text" @click="updateEmailGroupState(scope.row)">
            <!-- 恢复 -->
            <span v-if="scope.row.state == 0">{{
              $t("emailGroup.recover")
            }}</span>
            <!-- 作废 -->
            <span v-if="scope.row.state == 1">{{
              $t("emailGroup.void")
            }}</span></el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
export default {
  data() {
    return {
      emailGroupList: []
    };
  },
  methods: {
    // 选择的标签
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 查询用户信息
    getAllEmailGroupList() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/emailGroupView/getAllEmailGroupList";
      this.$http
        .post(url)
        .then(response => {
          if (response.data.code === 200) {
            this.emailGroupList = response.data.data;
            loading.close();
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    //创建日期格式化时间
    createTimeFormat(row) {
      if (row.createTime != null && row.createTime != "") {
        return moment(row.createTime).format("YYYY-MM-DD");
      }
    },
    //创建日期格式化时间
    createTimeFormat1(row) {
      if (row.lastAnnouncement != null && row.lastAnnouncement != "") {
        return moment(row.lastAnnouncement).format("YYYY-MM-DD HH:mm");
      }
    },
    //  更新email群状态
    updateEmailGroupState(row) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/emailGroupView/updateEmailGroupState";
      this.$http
        .post(
          url,
          qs.stringify({ emailGroupId: row.emailGroupId, state: row.state })
        )
        .then(response => {
          if (response.data.code === 200) {
            this.$message.success(response.data.message);
            this.getAllEmailGroupList();
            loading.close();
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    }
  },
  mounted() {
    this.getAllEmailGroupList();
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}
>>> .el-table__row {
  height: 42px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}
>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/EmailMarketing/P0404.vue